/**
 * PWA update availability — tiny pub/sub bridging the service-worker
 * registration (main.tsx) to the in-app update toast.
 *
 * Using `registerType: 'prompt'` (vite.config) so a new version never
 * activates mid-session: the user refreshes when it suits them — important
 * for a timer app where an auto-reload would kill a running pomodoro.
 */

type Listener = () => void;

let updateReady = false;
let applyUpdate: (() => void) | null = null;
const listeners = new Set<Listener>();

export function subscribePwaUpdate(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isPwaUpdateReady(): boolean {
  return updateReady;
}

export function applyPwaUpdate(): void {
  applyUpdate?.();
}

/** Called from main.tsx when the SW reports a waiting new version. */
export function markPwaUpdateReady(apply: () => void): void {
  applyUpdate = apply;
  if (!updateReady) {
    updateReady = true;
    listeners.forEach((listener) => listener());
  }
}
